<div *ngIf="customerInteraction || customerInteractionId === 'new' || insideCard" class="columns"
     [ngClass]="{'mt-6': !insideCard}">
    <div class="column is-1"></div>
    <div class="column has-round-border is-15" [ngClass]="{'card': !insideCard}">

        <div *ngIf="!insideCard" class="columns custom-card-header mb-5">
            <div class="column is-narrow pl-5 is-flex is-justify-content-center is-align-items-center">
                <a class="is-clickable color-white" (click)="back()">
                    <fa-icon [icon]="faArrowLeft"></fa-icon>
                </a>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div *ngIf="customerInteraction?.message">

                    <!--first message of a customer interaction when its not a customer request-->
                    <div *ngIf="customerInteraction?.type.toString() !== 'CUSTOMER_REQUEST'" class="columns">
                        <div class="column pr-0 docestate-chat-icon-container">
                            <img class="custom-img docestate-chat-icon" src="favicon.ico" alt="DocEstate Logo">
                            <p class="is-size-7">{{customerInteraction?.date | date: 'dd.MM.yyy'}}</p>
                        </div>
                        <div class="column pl-0">
                            <div class="bubble-left is-flex is-align-items-center p-2">
                                <p class="pre-line">{{customerInteraction?.message}}</p>
                            </div>
                        </div>
                    </div>

                    <!--first message of a customer interaction when its a customer request-->
                    <div *ngIf="customerInteraction?.type.toString() === 'CUSTOMER_REQUEST'" class="columns">
                        <div class="column pl-0">
                            <div class="bubble-right is-flex is-align-items-center is-justify-content-end margin-left-auto p-2">
                                <p class="mr-3 pre-line">{{customerInteraction?.message}}</p>
                            </div>
                        </div>
                        <div class="column docestate-chat-icon-container has-text-centered margin-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32.41" height="32.41"
                                 viewBox="0 0 42.41 42.41">
                                <path id="Icon_material-account-circle" data-name="Icon material-account-circle" d="M24.2,3a21.2,21.2,0,1,0,21.2,21.2A21.213,21.213,0,0,0,24.2,3Zm0,6.361a6.361,6.361,0,1
                                1-6.361,6.361A6.353,6.353,0,0,1,24.2,9.361Zm0,30.111a15.269,15.269,0,0,1-12.723-6.828c.064-4.22,8.482-6.531,12.723-6.531,4.22,0,12.659,2.311,12.723,6.531A15.269,15.269,0
                                01,24.2,39.472Z" transform="translate(-3 -3)" fill="#35566e"/>
                            </svg>
                            <p class="is-size-7">{{customerInteraction?.date | date: 'dd.MM.yyyy'}}</p>
                        </div>
                    </div>

                    <!--List all responses for the customer interaction-->
                    <div *ngFor="let response of customerInteraction?.responses" class="columns">
                        <ng-container *ngIf="response.author && response.author.toString() === 'USER'">
                            <div class="column">
                                <div class="bubble-right is-flex is-align-items-center margin-left-auto p-2">
                                    <p (click)="inspectChangedData(response)"
                                       class="mr-3 color-white is-underline is-pulled-right pre-line"
                                       [ngStyle]="isResponseClickable(response) ? {'text-decoration':'underline'} : {'text-decoration':'none'}"
                                       [ngClass]="(isResponseClickable(response))?'is-clickable':''">
                                        {{getTextFromResponse(response)}}
                                    </p>
                                </div>
                            </div>
                            <div class="column docestate-chat-icon-container has-text-centered margin-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32.41" height="32.41"
                                     viewBox="0 0 42.41 42.41">
                                    <path id="Icon_material-account-circle" data-name="Icon material-account-circle" d="M24.2,3a21.2,21.2,0,1,0,21.2,21.2A21.213,21.213,0,0,0,24.2,3Zm0,6.361a6.361,6.361,0,1
                                    1-6.361,6.361A6.353,6.353,0,0,1,24.2,9.361Zm0,30.111a15.269,15.269,0,0,1-12.723-6.828c.064-4.22,8.482-6.531,12.723-6.531,4.22,0,12.659,2.311,12.723,6.531A15.269,15.269,0
                                    01,24.2,39.472Z" transform="translate(-3 -3)" fill="#35566e"/>
                                </svg>
                                <p class="is-size-7">{{response.date | date: 'dd.MM.yyyy'}}</p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="response.author && response.author.toString() === 'DOCESTATE'">
                            <div class="column docestate-chat-icon-container pr-0">
                                <img class="custom-img docestate-chat-icon" src="favicon.ico" alt="DocEstate Logo">
                                <p class="is-size-7">{{response?.date | date: 'dd.MM.yyyy'}}</p>
                            </div>
                            <div class="column pl-0">
                                <div class="bubble-left is-flex is-align-items-center pl-2">
                                    <p (click)="inspectChangedData(response)" class="color-white pre-line"
                                       [ngStyle]="isResponseClickable(response) ? {'text-decoration':'underline'} : {}"
                                       [ngClass]="(isResponseClickable(response))?'is-clickable':''">
                                        {{getTextFromResponse(response)}}
                                    </p>
                                </div>
                            </div>
                        </ng-container>
                    </div>


                    <!--default message after adding a new response or when inspecting a customer interaction that was already answered-->
                    <div *ngIf="customerInteraction?.status.toString() === 'WAITING_FOR_DOCESTATE' || doneLoading">
                        <div class="columns">
                            <div class="column docestate-chat-icon-container pr-0">
                                <img class="custom-img docestate-chat-icon" src="favicon.ico" alt="DocEstate Logo">
                                <p class="is-size-7">{{getLatestResponseDate() | date: 'dd.MM.yyy'}}</p>
                            </div>
                            <div class="column pl-0">
                                <div class="bubble-left is-flex is-align-items-center pl-2">
                                    <p>Vielen Dank. Die eingereichten Daten werden nun von uns überprüft.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--message that is shown when something went wrong during the upload of a authority-->
                    <div *ngIf="errorDuringResponse">
                        <div class="columns">
                            <div class="column docestate-chat-icon-container pr-0">
                                <img class="custom-img docestate-chat-icon" src="favicon.ico" alt="DocEstate Logo">
                                <p class="is-size-7">{{getLatestResponseDate() | date: 'dd.MM.yyy'}}</p>
                            </div>
                            <div class="column pl-0">
                                <div class="bubble-left is-flex is-align-items-center pl-2">
                                    <p>Entschuldigung. Da ist etwas schief gelaufen. <a (click)="reloadPage()">Bitte
                                        versuchen Sie es erneut...</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr *ngIf="!insideCard">

        <div class="columns">
            <div class="column">

                <p *ngIf="isInvalid" class="has-text-centered mb-4 is-bold required">Bitte laden Sie mindestens eine
                    Datei hoch oder stellen Sie und benötigte Informationen zur Verfügung.</p>
                <p *ngIf="isMissingDescription" data-testid="ci-missing-description"
                   class="has-text-centered mb-4 is-bold required">Bitte beschreiben Sie Ihr Anliegen.</p>
                <p *ngIf="errorDuringCreation" data-testid="ci-creation-error"
                   class="has-text-centered mb-4 is-bold required">Ihre Anfrage konnte leider nicht übermittelt werden.
                    Bitte versuchen Sie es erneut.</p>

                <div class="columns">
                    <div *ngIf="!insideCard" class="column is-3"></div>
                    <div class="column">
                        <!--text input for a ci / ci-response-->
                        <div class="has-text-centered title is-4 is-bold color-darkblue">
                            Informationen bereitstellen
                        </div>
                        <p *ngIf="insideCard" class="m-4">
                            Schildern Sie uns hier gerne Ihr Anliegen. Um Ihnen schnellstmöglich helfen zu können, geben
                            Sie uns bitte alle relevanten Informationen an.
                        </p>
                        <!--scope selection: a new request is either general or refers to specific documents-->
                        <div *ngIf="customerInteractionId === 'new'" class="mt-4">
                            <p class="is-bold mb-2">Worauf bezieht sich Ihr Anliegen?</p>
                            <div class="mb-1">
                                <label class="radio">
                                    <input type="radio" name="interactionScope" value="GENERAL"
                                           [(ngModel)]="interactionScope">
                                    Allgemein bzw. alle Auskünfte
                                </label>
                            </div>
                            <div>
                                <label class="radio">
                                    <input type="radio" name="interactionScope" value="DOCUMENTS"
                                           [(ngModel)]="interactionScope">
                                    Bestimmte Auskünfte
                                </label>
                            </div>

                            <div *ngIf="interactionScope === 'DOCUMENTS'" class="mt-3 ml-4">
                                <div class="mb-1" *ngFor="let document of property?.documents">
                                    <label class="checkbox">
                                        <input type="checkbox"
                                               [checked]="selectedDocumentIds.includes(document.docid)"
                                               (change)="toggleDocumentSelection(document.docid)">
                                        {{ getLongName(document.docname) }}
                                    </label>
                                </div>
                                <p *ngIf="isMissingDocumentSelection" class="mt-2 is-bold required">
                                    Bitte wählen Sie mindestens eine Auskunft aus.
                                </p>
                            </div>
                        </div>

                        <div class="text-area-container p-3 has-round-border is-flex is-justify-content-center is-align-items-center has-box-shadow mt-3 mb-3">
                            <textarea class="w-100 no-border" #textResponse rows="10"
                                      placeholder="Informations eingabe..."></textarea>
                        </div>

                        <!--file upload for a new customer interaction inside the modal (no nested file modal is used here)-->
                        <div *ngIf="insideCard" class="mb-3" data-testid="ci-file-upload">
                            <p class="is-bold mb-1">Dateien anhängen (optional)</p>
                            <p class="is-size-7 mb-2">Sie können eine oder mehrere PDF-Dateien mit insgesamt maximal
                                20 MB anhängen.</p>
                            <app-dropzone #authorityDropzone
                                          [getUploadedFiles]="false"
                                          [appendFiles]="true"
                                          [percentWidth]="100"
                                          dropzoneImage="assets/images/dropzone/upload-icon2.svg"></app-dropzone>
                        </div>
                    </div>
                    <div *ngIf="!insideCard" class="column is-3"></div>
                </div>

                <ng-container>
                    <div class="columns">
                        <div class="column is-3"></div>
                        <div *ngIf="!insideCard" class="column is-flex is-justify-content-center is-align-items-center">
                            <button class="button buy-button is-size-6 has-round-border no-border is-block has-background-white has-border color-blue"
                                    (click)="showAddFileModal=true" [ngClass]="{'disabled': isLoading && !doneLoading}">
                                <p class="is-bold">Datei hinzufügen</p>
                            </button>
                        </div>
                        <div class="column" *ngIf="customerInteraction || customerInteractionId === 'new'">
                            <a (click)="finishCustomerInteraction()"
                               class="button buy-button is-size-6 has-round-border no-border is-block"
                               [ngClass]="{'disabled is-loading': isLoading && !doneLoading}">
                                <div class="columns is-align-items-center is-justify-content-center pt-2">
                                    <div class="column">
                                        <p class="is-bold">Abschicken</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="column is-3"></div>
                    </div>
                    <div *ngIf="!insideCard" class="columns">
                        <div class="column is-3" *ngIf="authorityDropzoneComponent.files"></div>
                        <div class="column">
                            <div class="files-list"
                                 *ngFor="let file of authorityDropzoneComponent.files; let index = index">
                                <p appTooltip matTooltip="{{file.file.name}}" class="truncate">{{ file.file.name }}</p>
                                <button class="delete" (click)="deleteFile(index)">
                                </button>
                            </div>
                        </div>
                        <div class="column is-3"></div>
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
    <div class="column is-1"></div>
</div>

<!--file upload for responses to an existing customer interaction-->
<app-modal *ngIf="!insideCard" [active]="showAddFileModal" (modalClosed)="showAddFileModal=false">
    <div class="columns">
        <div class="column">
            <div class="has-text-centered title is-4 is-bold color-darkblue">
                Datei hinzufügen
            </div>
            <div>
                <app-dropzone [getUploadedFiles]="false"
                              #authorityDropzone
                              dropzoneImage="assets/images/dropzone/upload-icon2.svg"></app-dropzone>
            </div>
        </div>
    </div>
    <div class="columns">
        <div class="column is-one-third"></div>
        <div class="column is-one-third">
            <button class="button buy-button is-size-6 has-round-border no-border is-block"
                    (click)="showAddFileModal=false">Bestätigen
            </button>
        </div>
        <div class="column is-one-third"></div>
    </div>
</app-modal>

<app-property-information *ngIf="inspectingProperty" [showBillingAndBeneficiary]="false"
                          [informationProperty]="inspectingProperty"
                          [showPropertyInformationModal]="showInspectChangedDataModal"
                          (modalClosed)="showInspectChangedDataModal=false;inspectingProperty = null"></app-property-information>
